// extracted by css-extract-rspack-plugin
export default {"container":"lazy__container--O5h_N","loading":"lazy__loading--RGLM6","error":"lazy__error--nzySq"};